import { render, staticRenderFns } from "./material-section.vue?vue&type=template&id=033d343e&scoped=true"
import script from "./material-section.vue?vue&type=script&setup=true&lang=js"
export * from "./material-section.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-section.vue?vue&type=style&index=0&id=033d343e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033d343e",
  null
  
)

export default component.exports